import { render, staticRenderFns } from "./ElderDiet.vue?vue&type=template&id=2ef5c5c6&scoped=true&"
import script from "./ElderDiet.vue?vue&type=script&lang=js&"
export * from "./ElderDiet.vue?vue&type=script&lang=js&"
import style0 from "./ElderDiet.vue?vue&type=style&index=0&id=2ef5c5c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5c5c6",
  null
  
)

export default component.exports